export default __webpack_public_path__ + "static/media/mobile-phone-bottom.26c09f37.png";